<template>
  <div class="PartnersPage-page">
    <div class="header">
      <h2>合作机构</h2>
      <p class="subtitle">国内云计算 / 边缘加速 / 实时音视频 / 物联与影像生态伙伴</p>
    </div>

    <div class="partners-grid">
      <a
        v-for="(p, i) in partners"
        :key="i"
        class="partner-card"
        :href="p.url"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div class="partner-name">{{ p.name }}</div>
        <div class="partner-desc">{{ p.desc }}</div>
        <span class="partner-badge">{{ p.tag }}</span>
        <span class="partner-link">访问官网 →</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnersPage',
  data() {
    return {
      partners: [
        // 云计算 / AI 平台
        { name: '阿里云', url: 'https://cn.aliyun.com/', tag: '云计算', desc: '计算/存储/网络/数据库/AI 全栈' },
        { name: '腾讯云', url: 'https://cloud.tencent.com/', tag: '云/音视频', desc: '公有云 + TRTC 实时音视频' },
        { name: '华为云', url: 'https://www.huaweicloud.com/', tag: '企业云', desc: 'IaaS/PaaS/SaaS 与行业方案' },
        { name: '百度智能云', url: 'https://cloud.baidu.com/', tag: 'AI 云', desc: '文心模型/飞桨/多模态 AI 能力' },
        { name: '火山引擎', url: 'https://www.volcengine.com/', tag: 'AI/云原生', desc: '字节系云与大模型平台' },
        { name: '移动云', url: 'https://www.cmecloud.com/', tag: '运营商云', desc: '算力网络/边缘云/镜像站' },
        { name: '联通云', url: 'https://www.cucloud.cn/', tag: '运营商云', desc: '云网一体、数智相融' },

        // CDN / 存储 / 边缘
        { name: '七牛云', url: 'https://www.qiniu.com/', tag: '音视频/存储', desc: '对象存储、点播/直播、CDN' },
        { name: 'UCloud', url: 'https://www.ucloud.cn/', tag: '中立云', desc: '科创板上市中立云服务商' },

        // 影像/物联厂商（你点名的三家已包含）
        { name: '大疆 DJI', url: 'https://www.dji.com/cn', tag: '无人机/影像', desc: '航拍/行业无人机与影像生态' },
        { name: '海康威视', url: 'https://www.hikvision.com/cn/', tag: 'AIoT/安防', desc: '视频物联与行业解决方案' }
      ]
    }
  }
}
</script>

<style scoped>
.PartnersPage-page {
  min-height: 100%;
  padding: 24px;
  background: #0b1623;
  color: #e7f1ff;
  box-sizing: border-box;
}
.header h2 {
  margin: 0;
  font-size: 22px;
  letter-spacing: .5px;
}
.subtitle {
  margin: 6px 0 18px;
  opacity: .8;
  font-size: 13px;
}
.partners-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
}
.partner-card {
  display: block;
  padding: 16px;
  border-radius: 16px;
  text-decoration: none;
  color: inherit;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
}
.partner-card:hover {
  transform: translateY(-2px);
  border-color: rgba(64, 160, 255, .6);
  box-shadow: 0 8px 24px rgba(64, 160, 255, .18);
}
.partner-name {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: .3px;
}
.partner-desc {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.55;
  opacity: .9;
}
.partner-badge {
  display: inline-block;
  margin-top: 10px;
  padding: 2px 8px;
  font-size: 11px;
  border-radius: 999px;
  background: rgba(64, 160, 255, .12);
  border: 1px solid rgba(64, 160, 255, .35);
}
.partner-link {
  display: inline-block;
  margin-top: 10px;
  font-size: 12px;
  opacity: .95;
}
</style>
